//主页面
const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');

// 应收票据汇总
const collectBillManage = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/collectPayBillManage/collectBill/list.vue')),
    'collectBillManage'
  );
// 应收票据开立
const collectBillAdd = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/collectPayBillManage/collectBill/add.vue')),
    'collectBillAdd'
  );
// 应收票据编辑
const collectBillEdit = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/collectPayBillManage/collectBill/edit.vue')),
    'collectBillEdit'
  );
// 应收票据详情
const collectBillDetails = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/collectPayBillManage/collectBill/details.vue')),
    'collectBillDetails'
  );
// 应付票据汇总
const payBillManage = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/collectPayBillManage/payBill/list.vue')),
    'payBillManage'
  );

// 应付票据编辑
const payBillEdit = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/collectPayBillManage/payBill/edit.vue')),
    'payBillEdit'
  );
// 应付票据详情
const payBillDetails = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/capitalCenter/collectPayBillManage/payBill/details.vue')),
    'payBillDetails'
  );

const capitalRouter = {
  path: '/capital',
  component: index,
  children: [
    {
      path: 'collectBillManage',
      name: 'collectBillManage',
      component: collectBillManage,
      meta: {
        keepAlive: true,
        title: '应收票据',
      },
    },
    {
      path: 'collectBillAdd',
      name: 'collectBillAdd',
      component: collectBillAdd,
      meta: {
        keepAlive: true,
        title: '应收票据创建',
      },
    },
    {
      path: 'collectBillEdit',
      name: 'collectBillEdit',
      component: collectBillEdit,
      meta: {
        keepAlive: true,
        title: '应收票据修改',
      },
    },
    {
      path: 'collectBillDetails',
      name: 'collectBillDetails',
      component: collectBillDetails,
      meta: {
        keepAlive: true,
        title: '应收票据详情',
      },
    },
    {
      path: 'payBillManage',
      name: 'payBillManage',
      component: payBillManage,
      meta: {
        keepAlive: true,
        title: '应付票据',
      },
    },
    {
      path: 'payBillAdd',
      name: 'payBillAdd',
      component: () => import('@/pages/capitalCenter/collectPayBillManage/payBill/add.vue'),
      meta: {
        keepAlive: true,
        title: '应付票据创建',
      },
    },
    {
      path: 'payBillEdit',
      name: 'payBillEdit',
      component: payBillEdit,
      meta: {
        keepAlive: true,
        title: '应付票据修改',
      },
    },
    {
      path: 'payBillDetails',
      name: 'payBillDetails',
      component: payBillDetails,
      meta: {
        keepAlive: true,
        title: '应付票据详情',
      },
    },
  ],
};
export default capitalRouter;
